import { TypeFormatFlags } from "typescript";
import axios from "../../utilities/axios";
import { Event } from "../Event";

export class CompanyEvents extends Event {
    public onLoad = () => {

    }
}